export const NotificationTypes = Object.freeze({
	SUCCESS: Symbol("success"),
	INFO: Symbol("info"),
	WARNING: Symbol("warning"),
	ERROR: Symbol("error"),
});
